
import { defineComponent, computed, onMounted, watch } from 'vue';
import { useStore } from 'src/store';
import { connectWS, disconnectWS } from 'src/services/connection';

export default defineComponent({
  name: 'App',
  setup() {
    const $store = useStore();
    const isLoggedIn = computed(() => $store.getters['app/isLogged']);

    onMounted(() => {
      if (isLoggedIn.value) {
        connectWS();
      }
    });

    watch(isLoggedIn, (isLogged) => {
      process.env.DEBUGGING &&
        console.info('WATCH isLoggedIn:', isLoggedIn.value);
      isLogged ? connectWS() : disconnectWS();
    });
  },
});
